// extracted by mini-css-extract-plugin
export default {"link-preview":"LinkPreview_link-preview__afFqg","link-label":"LinkPreview_link-label__QqD9q","truncate":"LinkPreview_truncate__TMPvR"};